import React from "react";
import ReactDOM from "react-dom/client";
import { registerSW } from "virtual:pwa-register";
import "@digital-go-jp/design-tokens/dist/tokens-simple.css";
import "maplibre-gl/dist/maplibre-gl.css";
import { App } from "./App";
import "./styles.css";
import "./dads-theme.css";

registerSW({ immediate: true });

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
